import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.event.onFetchSignUpsForPeriodOfDaysByCountry.add((data) => {
            this.setState({
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList: data.chartData.seriesDataList,
                renderChart : true
            });
        });

        Service.fetchSignUpStatsByCountry(30);
    }

    componentWillUnmount() {

    }

    render() {

        const options = {
            title: {
                text: 'Histogram Sign Ups by Country for the last 30 days (top 20)'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Number of sign ups by country'
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                    }
                }
            },
            series: [{
                name: 'Sign Ups over last 30 days',
                type: 'column',
                colorByPoint: true,
                data: this.state.histogramChartSeriesDataList
            }]
        };

        return (
            <div>
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;